import { and } from "@/Common/helpers/sonar";
import { useIsWashoutReview } from "@/Washouts/hooks/WashoutReview/useIsWashoutReview";

const CYCLE_FINALIZED_STATUSES = ["FINALIZED", "POSTED"];
const POSITION_APPROVED_STATUSES = ["APPROVED"];

type IsWashoutEditableProps = {
	cycleStatus?: string;
	positionStatus?: string;
	hasRole?: boolean;
};

export const useIsWashoutEditable = ({ cycleStatus = "", positionStatus = "", hasRole = false }: IsWashoutEditableProps) => {
	const isWashoutReview = useIsWashoutReview();
	return and(
		isWashoutReview,
		hasRole,
		!CYCLE_FINALIZED_STATUSES.includes(cycleStatus),
		!POSITION_APPROVED_STATUSES.includes(positionStatus)
	);
};
